<div
  class="inputWrapper"
  [class.active]="isFilterActive()"
  [attr.style]="arrowIcon"
  [class.has-item]="hasItemSelected"
  (click)="open($event)"
>
  <img
    class="brand"
    width="18"
    *ngIf="hasItemSelected && (filterValue || filterValue === 0)"
    src="/assets/img/brands/{{ filterValue.brand || 'neighborhood' }}/logo.svg"
  />
  <input
    #search
    class="search"
    type="text"
    [value]="getPlaceholder()"
    (click)="open($event)"
    (blur)="blurClose()"
    (keyup)="onSearch($event)"
    placeholder="{{ title | translate }}"
    [disabled]="hasItemSelected"
  />
  <div class="clearBtn" *ngIf="canClear()" (click)="clear($event)"></div>
</div>
<div class="filter custom-scrollbar" [attr.style]="optTextColor">
  <ul *ngIf="filteredItems?.length; else nodataTemplate">
    <li
      *ngFor="let item of filteredItems"
      [attr.class]="item.class"
      (mousedown)="selectitem($event, item)"
      [attr.data-value]="item.value"
    >
      <img
        *ngIf="item.brand"
        width="20"
        src="/assets/img/brands/{{ item.brand }}/logo.svg"
      />
      {{ item.label | translate }}
    </li>
  </ul>
  <ng-template #nodataTemplate>
    <div class="nodata">
      {{ 'No data' | translate }}
    </div>
  </ng-template>
</div>
